import * as React from "react";
import * as VCResources from "VersionControl/Scripts/Resources/TFS.Resources.VersionControl";
import * as Utils_String from "VSS/Utils/String";
import { DefaultButton } from "OfficeFabric/Button";
import { Dialog } from "VSSUI/Dialog";
import { DirectionalHint } from "OfficeFabric/common/DirectionalHint";
import { IContextualMenuItem } from "OfficeFabric/ContextualMenu";
import { KeyCodes } from "OfficeFabric/Utilities";

export interface ICreateButtonProps {
    isActive: boolean;
    draftIsDefault: boolean;
    onCreate(event: React.SyntheticEvent<any>, isDraft?: boolean): void;
    numWorkItems: number;
}

export interface CreateButtonDialogState {
    showDialog: boolean;
    onSave: (event: React.SyntheticEvent<any>) => void;
}

export class CreateButton extends React.Component<ICreateButtonProps, CreateButtonDialogState> {

    constructor(props: ICreateButtonProps) {
        super(props);
        this.state = {
            showDialog: false,
            onSave: this.props.draftIsDefault ? this.createDraftHandler : this.createHandler,
        } as CreateButtonDialogState;
    }

    createDraftHandler = (event: React.SyntheticEvent<any>) => { this.props.onCreate(event, true); };
    createHandler = (event: React.SyntheticEvent<any>) => { this.props.onCreate(event, false); };

    private _showDialog = (isDraft: boolean) => {
        this.setState({
            showDialog: true,
            onSave: isDraft ? this.createDraftHandler : this.createHandler,
        });
    }

    private _closeDialog = () => {
        this.setState({
            showDialog: false
        });
    }

    private _handleCreate = (event: React.SyntheticEvent<any>) => {
        this.props.numWorkItems >= 10 ? this._showDialog(false) : this.createHandler(event);
    }

    private _handleCreateDraft = (event: React.SyntheticEvent<any>) => {
        this.props.numWorkItems >= 10 ? this._showDialog(true) : this.createDraftHandler(event);
    }

    render() {
        let createContextItem = {
            key: "create-item",
            name: VCResources.ModalDialogCreateButton,
            onClick: this._handleCreate,
            disabled: !this.props.isActive,
        } as IContextualMenuItem;

        let createDraftContextItem = {
            key: "create-draft-item",
            name: VCResources.CreateAsDraft,
            iconProps: { iconName: "EditNote" },
            onClick: this._handleCreateDraft,
            disabled: !this.props.isActive,
        } as IContextualMenuItem;

        return (
            <div>
                <DefaultButton
                    primary
                    split
                    disabled={!this.props.isActive}
                    splitButtonAriaLabel={VCResources.CreatePullRequestMenuLabel}
                    menuTriggerKeyCode={KeyCodes.down}
                    menuProps={{
                        items: [
                            createContextItem,
                            createDraftContextItem
                        ],
                        directionalHint: DirectionalHint.bottomRightEdge,
                    }}
                    iconProps={this.props.draftIsDefault ? { iconName: "EditNote" } : undefined}
                    onClick={this.props.draftIsDefault ? this._handleCreateDraft : this._handleCreate}
                >
                    {this.props.draftIsDefault ? VCResources.CreateAsDraft : VCResources.ModalDialogCreateButton}
                </DefaultButton>
                {this.state.showDialog &&
                    <Dialog
                        titleProps={{ text: Utils_String.format(VCResources.PullRequestCreate_WorkItemWarningDialogTitle, this.props.numWorkItems) }}
                        footerButtonProps={[
                            {
                                text: VCResources.ModalDialogCancelButton,
                                onClick: this._closeDialog,
                                disabled: !this.props.isActive
                            },
                            {
                                text: VCResources.ModalDialogCreateButton,
                                onClick: this._closeDialog && this.state.onSave,
                                primary: true,
                                disabled: !this.props.isActive
                            }
                        ]}
                        onDismiss={this._closeDialog}
                    >
                        {Utils_String.format(VCResources.PullRequestCreate_WorkItemWarningDialogText, this.props.numWorkItems)}
                    </Dialog>}
            </div>
        );
    }
}
